/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Exports
*/

/**
 * 
 */
export function BoxInnerLinks(props) {
  return (
    props.items.map((item, index) => (
      <Link
        key={ index }
        to={ `/${ props.group }/${ item.id }` }
        className={
          CssClassName([
            'block p-4', props.active && props.active.id === item.id ? 'bg-indigo-300' : null
          ])
        }
      >
        { item.name }
      </Link>
    ))
  );
}

BoxInnerLinks.propTypes = {
  items: PropTypes.array.isRequired,
  group: PropTypes.string.isRequired,
  active: PropTypes.object
};